/**
 * Action types for the membership management add-on.
 *
 * Namespaced with IDP_ to avoid collision with other add-ons in the store.
 * @module constants/ActionTypes
 */

export const IDP_GET_MEMBERSHIP = 'IDP_GET_MEMBERSHIP';
export const IDP_MEMBERSHIP_ACTION = 'IDP_MEMBERSHIP_ACTION';
export const IDP_MEMBERSHIP_DOWNLOAD = 'IDP_MEMBERSHIP_DOWNLOAD';
